import { render, staticRenderFns } from "./newSettlement.vue?vue&type=template&id=39d58af2&scoped=true&"
import script from "./newSettlement.vue?vue&type=script&lang=js&"
export * from "./newSettlement.vue?vue&type=script&lang=js&"
import style0 from "./newSettlement.vue?vue&type=style&index=0&id=39d58af2&scoped=true&lang=css&"
import style1 from "./newSettlement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d58af2",
  null
  
)

export default component.exports